import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/product-editor",
  generate: "/product-editor/:productId"
};
